import React from 'react';

const useTimer = (
  remainingTime: number
): {
  counter: number;
  setCounter: React.Dispatch<React.SetStateAction<number>>;
} => {
  const [counter, setCounter] = React.useState(remainingTime);
  /* eslint-disable consistent-return */
  React.useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);

    if (timer) {
      return () => {
        clearInterval(timer);
      };
    }
  }, [counter]);

  return { counter, setCounter };
};

export default useTimer;
